import { Component } from "react";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { hideAddNewItemsModal } from "../redux-state/features/storeMgmt/storeMgmtSlice";
import { faPen, faPlus, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { showSuccess, showError } from "../utils";
import urls from "../urls";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import StoreItemsSelect from "./storeItemsSelect";
import SuppliersSelect from "../shared-components/suppliers-select";
import { setSelectedSupplier } from "../redux-state/features/orderState";
class AddNewItemsToStore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderUuid: uuidv4(), // Single UUID for the entire order
      items: [], // Array of items in the order
      selectedItem: null, // Store selected item from StoreItemsSelect
      quantity: 1, // Default quantity
      price: 0,
      editItemId: null, // Index of the item being edited
      editItem: null, // Store selected item for editing
      editItemQuantity: 1, // Quantity of the item being edited
      supplier: "",
      editSupplier: "",
      editPrice: 0,
    };
  }

  handleItemSelect = (selectedItem) => {
    this.setState({ selectedItem });
  };

  handleQuantityAndPriceChange = (e, item_name) => {
    const minimum = item_name === "quantity" ? 1 : 0;

    const value = Math.max(minimum, parseInt(e.target.value, 10)); // Ensure minimum quantity is 1

    this.setState({ [item_name]: value });
  };

  handleAddItem = (e) => {
    if (this.state.selectedItem) {
      const { selectedItem, quantity, items, price } = this.state;
      const supplier = this.props.selectedSupplier.label;
      const supplier_id = this.props.selectedSupplier.value;

      // Check if the item already exists in the order
      const existingItemIndex = items.findIndex(
        (item) => item.item_uuid === selectedItem.value
      );

      if (existingItemIndex !== -1) {
        // If the item exists, update its quantity
        const updatedItems = [...items];
        updatedItems[existingItemIndex].price = price;
        updatedItems[existingItemIndex].quantity += quantity;
        updatedItems[existingItemIndex].supplier = supplier;
        updatedItems[existingItemIndex].supplier_id = supplier_id;
        this.setState({ items: updatedItems });
      } else {
        // If the item does not exist, add it to the order
        const newItem = {
          item_name: selectedItem.label,
          item_uuid: selectedItem.value,
          quantity: quantity,
          supplier,
          supplier_id,
          price,
        };
        this.setState({
          items: [...items, newItem],
        });
      }

      // Reset the selected item and quantity
      this.setState({
        selectedItem: null,
        quantity: 1,
        price: 0,
        supplier: "",
      });
    }
  };

  showEditItem = (index) => {
    const item = this.state.items[index];
    this.setState({
      editItemId: index,
      editItem: { label: item.item_name, value: item.item_uuid }, // Set editItem for StoreItemsSelect
      editItemQuantity: item.quantity,
      editPrice: item.price,
    });
  };

  handleEditItem = (e) => {
    if (e.key === "Enter" && this.state.editItem) {
      const updatedItems = [...this.state.items];
      updatedItems[this.state.editItemId] = {
        ...updatedItems[this.state.editItemId],
        quantity: this.state.editItemQuantity,
        price: this.state.editPrice,
      };
      this.setState({
        items: updatedItems,
        editItemId: null,
        editItem: null,
        editItemQuantity: 1,
        editSupplier: "",
        editPrice: 0,
      });
    }
  };

  handleDeleteItem = (index) => {
    const filteredItems = this.state.items.filter((_, i) => i !== index);
    this.setState({ items: filteredItems });
  };

  handleSaveChanges = () => {
    const supplier = this.props.selectedSupplier.label;
    const supplier_id = this.props.selectedSupplier.value;
    const orderData = {
      order_uuid: this.state.orderUuid, // Single UUID for the order
      supplier_id,
      supplier,
      items: this.state.items, // Array of items in the order
      faculty_id: this.props.faculty_id,
    };
    axios
      .post(urls.newInvoice, orderData)
      .then((response) => {
        showSuccess("تم إضافة المخزون بنجاح ");
        console.log(response.data);
        this.handleClose();
      })
      .catch((error) => {
        showError("حدث خطأ أثناء الحفظ ");
      });
  };

  handleClose = () => {
    this.props.hideAddNewItemsModal();
    this.reset();
  };
  handleSupplier = (e) => {
    const txt = e.target.value;
    this.setState({ supplier: txt });
  };
  reset = () => {
    this.props.setSelectedSupplier(null);
    this.setState({
      items: [],
      selectedItem: null, // Store selected item from StoreItemsSelect
      quantity: 1, // Default quantity
      editItemId: null, // Index of the item being edited
      editItem: null, // Store selected item for editing
      editItemQuantity: 1, // Quantity of the item being edited
      supplier: "",
      editSupplier: "",
      price: 0,
      editPrice: 0,
      editItemQuantity: 1,
    });
  };
  render() {
    const { show, allowPrice } = this.props;
    const priceAllowed = allowPrice === "usePrice";
    const {
      items,
      selectedItem,
      quantity,
      editItemId,
      editItem,
      editItemQuantity,
      supplier,
      editSupplier,
      editPrice,
      price,
    } = this.state;

    return (
      <Modal
        show={show}
        onHide={this.handleClose}
        backdrop="static"
        keyboard={false}
        size="xl"
        scrollable
        style={{ minHeight: "500px" }} // Set a minimum height for the modal
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "11px" }}>
            إضافة مواد جديدة الى المخزن
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "20px", maxHeight: "400px", overflowY: "auto" }}
        >
          {/* Inline Select and Quantity Input */}
          <div className="d-flex align-items-center gap-3">
            <div style={{ flex: 4 }}>
              <label className="form-label" style={{ fontSize: "11px" }}>
                اسم الموُرِّد
              </label>
              {/* <input
                type="text"
                className="form-control text-center "
                value={supplier}
                onChange={this.handleSupplier}
                 onKeyDown={this.handleAddItem}
                style={{ fontSize: "11px", height: "38px" }}
              />*/}
              <SuppliersSelect />
            </div>

            <div style={{ flex: 4 }}>
              <label className="form-label" style={{ fontSize: "11px" }}>
                التعيين
              </label>
              <StoreItemsSelect onItemSelect={this.handleItemSelect} />
            </div>

            <div style={{ width: "120px" }}>
              <label className="form-label" style={{ fontSize: "11px" }}>
                الكمية
              </label>
              <input
                type="number"
                className="form-control text-center "
                value={quantity}
                onChange={(e) =>
                  this.handleQuantityAndPriceChange(e, "quantity")
                }
                min={1}
                style={{ fontSize: "11px", height: "38px" }}
              />
            </div>
            {priceAllowed && (
              <div style={{ width: "120px" }}>
                <label className="form-label" style={{ fontSize: "11px" }}>
                  سعر الوحدة ( د ج )
                </label>
                <input
                  type="number"
                  className="form-control text-center "
                  value={price}
                  onChange={(e) =>
                    this.handleQuantityAndPriceChange(e, "price")
                  }
                  min={0}
                  style={{ fontSize: "11px", height: "38px" }}
                />
              </div>
            )}
            <div>
              <p className="text-white mb-1">ff</p>
              <button
                className="btn btn-primary"
                style={{ height: "35px" }}
                onClick={this.handleAddItem}
              >
                <FontAwesomeIcon icon={faPlus} />
                <span className="mx-3">إضافة الى القائمة</span>
              </button>
            </div>
          </div>
          <hr />
          {/* Items Table */}
          {items.length > 0 && (
            <table className="table mt-3">
              <thead>
                <tr>
                  <th>اسم المادة</th>
                  <th>الموُرِّد</th>
                  <th>الكمية</th>
                  {/* price  only if allowed in settings*/}
                  {priceAllowed && (
                    <>
                      <th>سعر الوحدة </th>
                      <th>المجموع </th>
                    </>
                  )}

                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.item_name}</td>
                    <td>{item.supplier}</td>
                    <td>
                      {editItemId === index ? (
                        <input
                          type="number"
                          className="form-control text-center"
                          value={editItemQuantity}
                          onChange={(e) =>
                            this.setState({
                              editItemQuantity: Math.max(
                                1,
                                parseInt(e.target.value, 10)
                              ),
                            })
                          }
                          onKeyDown={this.handleEditItem}
                          min={1}
                          style={{ fontSize: "11px", height: "38px" }}
                        />
                      ) : (
                        item.quantity
                      )}
                    </td>
                    {/* price  */}
                    {priceAllowed && (
                      <>
                        <td>
                          {editItemId === index ? (
                            <input
                              type="number"
                              className="form-control text-center"
                              value={editPrice}
                              onChange={(e) =>
                                this.setState({
                                  editPrice: Math.max(
                                    0,
                                    parseInt(e.target.value, 10)
                                  ),
                                })
                              }
                              onKeyDown={this.handleEditItem}
                              min={1}
                              style={{ fontSize: "11px", height: "38px" }}
                            />
                          ) : (
                            item.price
                          )}
                        </td>
                        <td>{(item.price * item.quantity).toFixed(2)} دج </td>
                      </>
                    )}

                    <td>
                      <button
                        className="btn border border-1"
                        title=""
                        onClick={() => this.showEditItem(index)}
                      >
                        <FontAwesomeIcon icon={faPen} size="lg" />
                      </button>
                      <button
                        className="btn border border-1 ms-3"
                        onClick={() => this.handleDeleteItem(index)}
                      >
                        <FontAwesomeIcon icon={faTrashCan} title="" size="lg" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          {" "}
          <Button variant="primary" onClick={this.handleSaveChanges}>
            حفظ التغييرات
          </Button>
          <Button variant="danger" onClick={this.reset}>
            إعادة تعيين
          </Button>
          <Button variant="secondary" onClick={this.handleClose}>
            إلغاء العملية
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapDispatchToProps = { hideAddNewItemsModal, setSelectedSupplier };
const mapStateToProps = (state) => ({
  show: state.StoreState.showAddNewItemsModal,
  selectedSupplier: state.orderState.selectedSupplier,
  allowPrice: state.settingState.invoice_price,
  faculty_id: state.userState.faculty_id,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddNewItemsToStore);
